import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const CheckRoundedIcon = CheckCircleIcon;
